import * as React from 'react';
import { UitkCard, UitkCardContent, UitkCardImageLayout, UitkCardMedia, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { AlternateDestination } from 'src/common/models';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { AlternateDestinationImage } from './alternate-destination-image';
import { AlternateDestinationLink } from './alternate-destination-link';

export interface AlternateDestinationCardProps {
  destination?: AlternateDestination;
  position: number;
}

export class AlternateDestinationCardSmall extends React.Component<AlternateDestinationCardProps> {
  public render() {
    const { destination, position } = this.props;

    if (!destination) {
      return null;
    }

    const isAirport = destination.type === 'AIRPORT';

    return (
      <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED} data-stid="alternate-destination-card-small">
        <UitkCardMedia>
          <UitkFigure ratio={UitkFigureAspectRatioType.R3_2}>
            <AlternateDestinationImage image={destination.image} />
          </UitkFigure>
        </UitkCardMedia>
        <UitkCardContent>
          <UitkCardTextSegment className="uitk-flex uitk-flex-column white-space-normal">
            <h4 className="uitk-type-400">
              {isAirport && <UitkIcon name="lob_flights" size={UitkIconSize.EXTRA_SMALL} className="all-r-margin-one" />}
              {destination.title}
            </h4>
            <div className="pwa-theme--grey-700">{destination.subTitle}</div>
          </UitkCardTextSegment>
          <AlternateDestinationLink
            id={destination.id}
            linkName={destination.title}
            position={position}
            searchUrl={destination.searchUrl}
          />
        </UitkCardContent>
      </UitkCard>
    );
  }
}
